module.exports = __webpack_public_path__ + "static/media/venus.548bb92e.svg";